import React,{Component} from 'react';
import { apisettigs } from '../../../src/settings.js';


class ListarSolicitacoes extends Component{
    constructor(props) {        
        super(props);

        this.state = {
            show: false,  
            rqid: null,
            orderSolics: [],
        };
    }

    showListarSolicitacoes = (reqid) => {
        this.setState({show: true});
        this.setState({rqid:reqid});

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), rid: reqid })
        };

        fetch(apisettigs.endpoints.listsolics, requestOptions).then(response => response.json())
        .then(data => {
            //console.log(data);
            this.setState({orderSolics: data});
        });

    }


    hideListarSolicitacoes = () => {
        this.setState({show: false});
        this.setState({rqid: null});
        this.setState({orderSolics:[]});
    }


    voltar = () => {
        this.hideListarSolicitacoes();
        this.props.showOrd();
    }



    render(){

        if(this.state.show === true){
            return(
                <>
                    <div className='msgTopCont mb-3'>
                        Solicitações de Origem
                    </div>

                    {this.state.orderSolics.map( (orderSolic) => { 
                        return ( 
                            <>
                                <div className='container mt-4'>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center' style={{width:'7rem', padding:'0 0 0 0.2rem'}}> 
                                            Dt.Lançamento
                                        </div>
                                        <div className='colText col- align-self-center' style={{ maxWidth:'59%'}}>
                                            {orderSolic.creadate}
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center' style={{width:'7rem', padding:'0 0 0 0.2rem'}}>
                                            Solicitante
                                        </div>
                                        <div className='colText col- align-self-center' style={{maxWidth:'59%'}}>
                                            {orderSolic.solic}
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center' style={{width:'7rem', padding:'0 0 0 0.2rem'}}>
                                            Dpto.Solicitante
                                        </div>
                                        <div className='colText col-  align-self-center' style={{maxWidth:'59%', paddingBottom:'.1rem'}}>
                                            {orderSolic.ccnum} - {orderSolic.ccname}
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center' style={{width:'7rem', padding:'0 0 0 0.2rem'}}>
                                            Observação
                                        </div>
                                        <div className='colText col- align-self-center' style={{maxWidth:'59%'}}>
                                            {orderSolic.comments}
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center '  style={{width:'7rem', padding:'0 0 0 0.2rem'}}>
                                            Valor
                                        </div>
                                        <div className='colText col-  align-self-center ' style={{maxWidth:'59%'}}>
                                            {orderSolic.value}
                                        </div>

                                    </div>

                                    <hr className='hLn'/>

                                </div>

                            </>); 
                        }
                    )}

                    <div className='container mt-4 mb-4 text-center'>
                        <button type="button" className="btn btn-outline-primary msgBtn2" onClick={this.voltar}>Voltar</button>
                    </div>

                </>
            );
        }
        else{
            return null;
        }
    }





}

export default ListarSolicitacoes